import { c as _c } from "react/compiler-runtime";
import { Heading } from '@chakra-ui/react';
import { Stack, Text } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { ChakraNextImage } from '@src/components/sco/utilities/ChakraNextImage';
interface HowItWorksCardProps {
  title: string;
  step?: number;
  image: string;
  imagePadding?: string;
  direction?: any;
  gradient?: string;
  bgColor?: string;
  boxShadow?: string;
  description?: string;
  titleColor?: string;
  titleSize?: string;
}
const HowItWorksCard = props => {
  const $ = _c(24);
  const t0 = props.bgColor || "colorPalette.container";
  const t1 = props.boxShadow || "sm";
  const t2 = props.direction || "column";
  const t3 = props.imagePadding || 5;
  const t4 = props.imagePadding || 0;
  let t5;
  if ($[0] !== props.image) {
    t5 = <Flex align="center" flex={2} justify="center"><ChakraNextImage alt="image" maxHeight="500px" src={props.image} width="auto" /></Flex>;
    $[0] = props.image;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = <Center height="full" p={t3} paddingBottom={t4} width="full">{t5}</Center>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== props.step) {
    t7 = props.step && <Text borderBottom="4px solid" borderColor="colorPalette.muted" color="colorPalette.text" paddingBottom={1} textAlign="center" textStyle="label">{"Step "}{props.step}</Text>;
    $[6] = props.step;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = props.titleColor || "colorPalette.text";
  let t9;
  if ($[8] !== props.title || $[9] !== props.titleSize || $[10] !== t8) {
    t9 = <Heading color={t8} fontSize={props.titleSize} textAlign="center">{props.title}</Heading>;
    $[8] = props.title;
    $[9] = props.titleSize;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== props.description) {
    t10 = props.description && <Text textAlign="center" textStyle="lg">{props.description}</Text>;
    $[12] = props.description;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7 || $[16] !== t9) {
    t11 = <Stack align="center" direction="column" gap={4} paddingBottom={10} paddingTop={5} paddingX={10} width="full">{t7}{t9}{t10}</Stack>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t11 || $[21] !== t2 || $[22] !== t6) {
    t12 = <Flex align="flex-start" bgColor={t0} borderRadius="2xl" boxShadow={t1} direction={t2} gap={0} justify="flex-start" padding={0} width="full">{t6}{t11}</Flex>;
    $[18] = t0;
    $[19] = t1;
    $[20] = t11;
    $[21] = t2;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
export default HowItWorksCard;